module.exports = __webpack_public_path__ + "img/b690143.png";